export default [
  'Active',
  'Inactive'
];


// WEBPACK FOOTER //
// src/constants/companyStatuses.js